// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"379":"96e6af62","427":"b2289cdb","569":"3421f22e","653":"63b9ba4e","657":"0ec42382","686":"d1b296c0","777":"11055b71","806":"ab42d7dc","993":"f76e85d9","998":"a34fc72c"}[chunkId] + ".js";
};